// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/*.error {*/\n/*    color: red;*/\n/*}*/\n/*Not sure why this was added*/\n/*.error {*/\n/*    color: #e74c3c;*/\n/*    font-size: 20px;*/\n/*    display: flex;*/\n/*    justify-content: center;*/\n/*}*/\n\n", ""]);
// Exports
module.exports = exports;
